import React from 'react';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Link as LINK } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const MapOutOfBoundErrorBox = ({
  setSearchLimitAlertBox,
  matches,
}: {
  setSearchLimitAlertBox: any;
  matches: boolean;
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        width: matches ? '70%' : 'clamp(300px, 50%, 500px)',
        bottom: 14 + '%',
        right: 5 + '%',
        zIndex: 3000,
        filter: 'drop-shadow(0 0 10px #00000033)',
        overflow: 'hidden',
      }}
    >
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert
          severity="error"
          color="info"
          action={
            <IconButton
              aria-label="close"
              size="large"
              onClick={() => {
                setSearchLimitAlertBox(false);
              }}
              sx={{
                color: '#037A90',
                marginTop: '-10px',
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{
            background: '#ebfcff',
            color: '#444',
          }}
        >
          {/* Using Link from react-router-dom as LINK as It dosen't reload the page and faster */}
          <AlertTitle sx={{ color: '#000' }}>Warning</AlertTitle>
          You are currently outside of your current market.{' '}
          <LINK to="/tailored/t" style={{ color: '#037A90', fontWeight: 500 }}>
            Create your custom market
          </LINK>{' '}
          or{' '}
          <span
            style={{
              color: '#111',
              fontWeight: 500,
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            search for a region on the top bar
          </span>
          . Airbtics covers every corner of the world.
          <div
            style={{
              position: 'absolute',
              bottom: -50,
              right: -30,
              width: '90px',
              height: '90px',
              borderRadius: '50%',
              background:
                'linear-gradient(132.66deg, #037A90 16.11%, rgba(106, 182, 178, 0.651042) 40.95%, rgba(196, 196, 196, 0) 85.24%)',
            }}
          />
        </Alert>
      </Stack>
    </div>
  );
};

export default MapOutOfBoundErrorBox;
